import { CtaProps } from 'src/modules/global/components/cta/Cta';

export interface EventEntity {
  name: string;
  description: string;
  start_date: Date;
  end_date: Date;
  button: CtaProps;
}

export enum EventsActions {
  FetchListingBegin = 'EVENTS/FETCH_LISTING/BEGIN',
  FetchListingSuccess = 'EVENTS/FETCH_LISTING/SUCCESS',
  FetchListingError = 'EVENTS/FETCH_LISTING/ERROR',
}

export interface EventsStore {
  isLoading: boolean;
  isLoaded: boolean;
  error: any;
  events: EventEntity[];
}
